import { render, staticRenderFns } from "./internshipreport.vue?vue&type=template&id=bcc49d4c&scoped=true"
import script from "./internshipreport.vue?vue&type=script&lang=js"
export * from "./internshipreport.vue?vue&type=script&lang=js"
import style0 from "./internshipreport.vue?vue&type=style&index=0&id=bcc49d4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc49d4c",
  null
  
)

export default component.exports